<script>

// function uploadStringAsFile(url, photoshootid, id, whole, callback){
//   fetch(url, {
//     method:'POST',
//     headers:{'Content-type':'application/json'},
//     credentials:'include',
//     mode:'cors',
//     body: JSON.stringify({
//       uploadchunk:true,
//       photoshootid: photoshootid,
//       fid:id,
//       chunk: whole
//     })
//   }).then(res=>res.json()).then(res=>{
//     if (res.err) {
//       callback(res.err);
//       url=null;
//       photoshootid=null;
//       id=null;
//       whole=null;
//       callback=null;
//       return;
//     }
//     callback(null);
//   }).catch(err=>{
//     callback(err.message);
//     url=null;
//     photoshootid=null;
//     id=null;
//     whole=null;
//     callback=null;
//   });
// }


// function uploadPhotos2(url, photoshootid, photos2, imgids, callback) {
//   if (photos2.length===0) {
//     callback(null);
//     return;
//   }

//   var p = photos2.shift();

//   fetch(url, {
//     method: 'POST',
//     headers: {'Content-type':'application/json'},
//     credentials:'include',
//     mode:'cors',
//     body: JSON.stringify({photoshootid:photoshootid, getuploadid:true})
//   }).then(res=>res.json()).then(res=>{
//     if (res.err) {
//       callback(res.err);
//       return;
//     }
//     uploadStringAsFile(url, photoshootid, res.id, p, (err)=>{
//       if (err) {
//         callback(err);
//         return;
//       }
//       imgids.push(res.id);
//       uploadPhotos2(url, photoshootid, photos2, imgids, callback);
//     });
//   }).catch(err=>{
//     callback(err.message);
//   });
// }

// function uploadPhotos(url, photoshootid, photos, callback) {
//   var imgids = [];
//   var photos2 = [];

//   for (var i=0; i<photos.length; i++) {
//     photos2.push(photos[i]);
//   }

//   uploadPhotos2(url, photoshootid, photos2, imgids, (err)=>{
//     if (err) {
//       callback(err);
//     }
//     else {
//       callback(null, imgids);
//     }

//     url=null;
//     photoshootid=null;
//     photos=null;
//     callback=null;
//   });
// }

async function recognisePlateForSL(host, p) {
  return new Promise((resolve)=>{
    fetch(host+'/recognise', {
      method:'POST',
      mode:'cors',
      credentials:'include',
      headers:{'Content-type':'application/json'},
      body:JSON.stringify({img:p, i:1, location:1})
    }).then(res=>res.json()).then(res=>{
      if (res.error){
        resolve('');
      }
      else {
        if (res && res.res && res.res.results && res.res.results.length>0) {
          resolve(res.res.results[0].plate.toUpperCase());
        }
        else {
          resolve('');
        }
      }
    });
  });
}

async function sleep(ms) {
  return new Promise((resolve)=>{
    setTimeout(()=>{resolve()}, ms);
  });
}

async function recognisePlatesForSL(item, callback) {
  for (var i in item.options.body.regs) {
    if (item.options.body.regs[i].p) {
      item.options.body.regs[i].reg = await recognisePlateForSL(item.url.replace('/savesl', ''), item.options.body.regs[i].p);
      await sleep(1000);
      if (item.options.body.regs[i].reg && item.options.body.regs[i].reg != '') {
        delete item.options.body.regs[i].p;
      }
    }
  }
  callback();
}

  class OfflineUploader {
    running=false
    queue=[]
    test=true

    
    constructor(testversion, host) {
      this.queue = [];
      this.test = testversion?true:false;
      this.$host = host;
      
      this.poll();
      if ('Notification' in window && Notification.permission === 'default') {
        Notification.requestPermission().then((result) => {
          console.log(result);
        });
      }
    }

    getErrors(callback) {
      var request = indexedDB.open("TFSPWAPostDB");
      request.onsuccess = function (event) {
        var db = event.target.result;
        var store;
        if (!db.objectStoreNames.contains('errorrequest')) {
          store = db.createObjectStore("errorrequest", { keyPath: 'id', autoIncrement: true });
        }
        else {
          var tx = db.transaction('errorrequest', 'readwrite');
          store = tx.objectStore('errorrequest');
        }
//        var store = tx.objectStore('errorrequest');
        var allRecords = store.getAll();
        allRecords.onsuccess = function () {
          console.log('getErrors store.getAll successful');
          callback(allRecords.result);
        }
      }

      request.onupgradeneeded = function (event) {
        var db = event.target.result;
        db.onerror = function (event) {
          console.log("Why didn't you allow my web app to use IndexedDB?!",event);
        };

//        var objectStore;
        if (!db.objectStoreNames.contains('errorrequest')) {
//          objectStore = 
          db.createObjectStore("errorrequest", { keyPath: 'id', autoIncrement: true });
        }
        else {
//          objectStore = 
          db.objectStoreNames.get('errorrequest');
        }
      }
    }

    getJobs(callback) {
      var request = indexedDB.open("TFSPWAPostDB");
      request.onsuccess = function (event) {
        var db = event.target.result;
        var store;
        if (!db.objectStoreNames.contains('postrequest')) {
          store = db.createObjectStore("postrequest", { keyPath: 'id', autoIncrement: true });
        }
        else {
          var tx = db.transaction('postrequest', 'readwrite');
          store = tx.objectStore('postrequest');
        }

        var allRecords = store.getAll();
        allRecords.onsuccess = function () {
          console.log('getJobs store.getAll successful');
          callback(allRecords.result);
        }
      }

      request.onupgradeneeded = function (event) {
        var db = event.target.result;
        db.onerror = function (event) {
          console.log("Why didn't you allow my web app to use IndexedDB?!",event);
        };

//        var objectStore;
        if (!db.objectStoreNames.contains('postrequest')) {
//          objectStore = 
          db.createObjectStore("postrequest", { keyPath: 'id', autoIncrement: true });
        }
        else {
//          objectStore = 
          db.objectStoreNames.get('postrequest');
        }
      }
    }

    uploadFile(filedata, type, callback, reportcb) {
      var options = {filedata:filedata, callback:callback, type:type, reportcb:reportcb, c:0, d:filedata.length};

      this.uploadChunk(options);
    }

    getUploadId(options) {
      var thiz = this;
      fetch(this.$host+'/getuploadidcmn', {
        method:'POST',
        headers:{'Content-type':'application/json'},
        credentials:'include',
        mode:'cors',
        body: JSON.stringify({required:true})
      }).then(res=>res.json()).then(res=>{
        if (res.error){
          options.callback(res.error);
          return;
        }

        options.id = res.uid;
        thiz.uploadChunk(options);

      }).catch(err=>{console.log('error:',err)});
    }

    uploadChunk(options) {
      var thiz = this;
      if (!options.id) {
        this.getUploadId(options);
        return;
      }

      var cs= options.d-options.c;
      if (cs > 256000) cs = 256000;

      if (options.reportcb) options.reportcb(options.c,options.d);

      if (cs===0) {
        options.callback(null, options.id);
        return;
      }

      var chunk = options.filedata.substr(options.c,cs);
      options.c+= cs;

      fetch(this.$host+'/uploadchunkcmn/'+options.id, {
        method:'POST',
        headers: {'Content-type':'application/octet-stream'},
        body: chunk,
        mode:'cors',
        credentails:'include'
      }).then(res=>res.json()).then(res=>{
        if (res.error) {
          options.callback(res.error);
          return;
        }

        if (options.reportcb) options.reportcb(options.c,options.d);

        thiz.uploadChunk(options);
        options=null;
        cs=null;
        chunk=null;
      }).catch(err=>{console.log('error:',err)});
    }

    uploadPhotoshootImages(record, callback) {
      var thiz = this;

      
      this.uploadFile(atob(record.options.photos[record.i].substr(23)), 'image/jpeg', (err, id) =>{
        if (err) {
          // error!
        }
        else {
          record.imageids.push(id);
          record.i++;
          if (record.i>= record.options.photos.length) {
            callback(null);
            return;
          }

          thiz.uploadPhotoshootImages(record, callback);
          record=null;
          callback=null;
        }
      });
    }

    processPhotoshoot(record) {
      console.log(record);
    }

    saveOLData(record, callback) {
      var o = {record:JSON.parse(record.options.body)};
      o.evidences = o.record.evidences;
      delete o.record.evidences;
      o.i=0;
      o.imageids=[];

      fetch(record.url,{
        method:'POST',
        headers:{'Content-type':'application/json'},
        mode:'cors',
        credentials:'include',
        body: JSON.stringify(o.record)
      }).then(res=>res.json()).then(res=>{
        if (res.error) {
          console.log('system error #294', res.error);
          return;
        }
        if (res.id) o.id=res.id;
        console.log('saveoldata.o:', o);
        callback(null, o);
      }).catch(err=>{
        console.log('system error #302', err);
      })
    }
    saveOLImages(record, callback){
      var thiz = this;

      this.uploadFile(atob(record.evidences[record.i].substr(23)), 'image/jpeg', (err, id) =>{
        if (err) {
          // error!
        }
        else {
          console.log('new id:', id);
          record.imageids.push(id);
          record.i++;
          if (record.i>= record.evidences.length) {
            callback(null);
            record=null;
            callback=null;
            thiz=null;
            return;
          }

          thiz.saveOLImages(record, callback);
          record=null;
          callback=null;
          thiz=null;
        }
      });
    }
    addOLImagesToOL(o) {
      fetch(this.$host+'/saveolimgs', {
        method:'POST',
        headers:{'Content-type':'application/json'},
        mode:'cors',
        credentials:'include',
        body: JSON.stringify({
          id:o.id,
          imageids: o.imageids
        })
      }).then(res=>res.json()).then(res=>{
        if (res.error) {
          console.log('application error #339', res);
        }
        else {
          console.log('yay', o);
        }
      }).catch(err=>{
        console.log('system error #338', err);
      })
    }

    poll() {
      var thiz = this;
      var wakeLock;
      if (navigator.onLine) {

        console.log('offlineuploader poll is online');

        thiz.l = new Date();

        var request = indexedDB.open("TFSPWAPostDB");
        request.onsuccess = function (event) {
          var db = event.target.result;
          var tx = db.transaction('postrequests', 'readwrite');
          var store = tx.objectStore('postrequests');
          var allRecords = store.getAll();
          allRecords.onsuccess = function () {
            
            console.log('store.getAll successful');
            if (allRecords.result && allRecords.result.length > 0) {
              var records = allRecords.result;

              if (records[0].url.indexOf('/savevpsmp') != -1) {
                store.delete(allRecords.result[0].id);
                // savevpsmp request, contains plate photo and n number of photos of the same vehicle
                // get an id from backend for the whole lot

                fetch(records[0].url, {
                  method:'POST',
                  headers: {'Content-type':'application/json'},
                  credentials:'include',
                  mode:'cors',
                  body: JSON.stringify({getpsid:true})
                }).then(res=>res.json()).then(res=>{
                  if (res.err) {
                    thiz.$error = {
                      title:'Application error OLUL #122',
                      message: res.err+'<Br>Uploading has been stopped.<br>This is an important message, please don\'t forget to screenshot or copy it and send it to Janos.'
                    }
                    return;
                  }
                  

                  //save photoshoot id
                  records[0].photoshootid= res.id;

                  // upload plate photo
                  thiz.uploadFile(atob(records[0].options.plate.substr(23)), 'image/jpeg', (err, id)=>{
                    records[0].plateid = id;
                    // plate photo uploaded

                    records[0].imageids = [];
                    // start uploading photoshoot images
                    records[0].i=0;
                    thiz.uploadPhotoshootImages(records[0], (err)=>{
                      if (err) {
                        console.log('system error #336', err);
                      }
                      // process images and save photoshoot in data store
                      thiz.processPhotoshoot(records[0]);
                    });
                  });
                });

                setTimeout(()=>{thiz.poll()}, 10000);
                return;
              }
              else if (records[0].url.indexOf('/saveol') != -1) {
                try {
                  navigator.wakeLock.request("screen").then((wl)=>{wakeLock=wl});
                } catch (err) {
                  // the wake lock request fails - usually system related, such being low on battery
                  console.log(`${err.name}, ${err.message}`);
                }
                store.delete(allRecords.result[0].id);
                thiz.saveOLData(records[0], (err,o)=>{
                  console.log('saveoldata returned');
                  if (err) console.log('system error OfflineUploader #343:',err);
                  if (o.evidences) {
                    thiz.saveOLImages(o, (err)=>{
                      console.log('saveolimages returned', o);
                      if (err) console.log('system error OfflineUploader #346:',err);
                      thiz.addOLImagesToOL(o);
                    });
                  }
                  if (wakeLock) wakeLock.release();
                  setTimeout(()=>{thiz.poll()}, 1000);
                });
                return;
              }
              else if (records[0].url.indexOf('/saveswapol') != -1 || records[0].url.indexOf('/savevcinol') != -1 || records[0].url.indexOf('/savevcoutol') != -1) {
                store.delete(allRecords.result[0].id);

                try {
                  navigator.wakeLock.request("screen").then((wl)=>{wakeLock=wl});
                } catch (err) {
                  // the wake lock request fails - usually system related, such being low on battery
                  console.log(`${err.name}, ${err.message}`);
                }

                fetch(records[0].url, {
                  method:'POST',
                  headers: {'Content-type':'application/json'},
                  credentials:'include',
                  mode:'cors',
                  body: records[0].options.body
                }).then(res=>res.json()).then(res=>{
                  if (wakeLock) wakeLock.release();
                  if (res.err) {
                    thiz.$error = {
                      title:'Application error SWAPOL #122',
                      message: res.err+'<Br>Uploading has been stopped.<br>This is an important message, please don\'t forget to screenshot or copy it and send it to Janos.'
                    }
                    return;
                  }
                  var url = records[0].url.indexOf('/saveswapol') != -1?'/saveswapol':records[0].url.indexOf('/savevcinol') != -1?'/savevcinol':'/savevcoutol';
                  alert(url+' has been saved successfully');
                });
                setTimeout(()=>{thiz.poll()}, 10000);
                return;
              }
              else if (records[0].url.indexOf('/savesl') != -1) {
                store.delete(allRecords.result[0].id);

                try {
                  navigator.wakeLock.request("screen").then((wl)=>{wakeLock=wl});
                } catch (err) {
                  // the wake lock request fails - usually system related, such being low on battery
                  console.log(`${err.name}, ${err.message}`);
                }

                navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill", msg:'Stocklist is being uploaded. Please wait...'}))});
                
                recognisePlatesForSL(records[0], ()=>{
                  // we tried recognising all plates,
                  //  so it's time to upload what's left
                  fetch(records[0].url, {
                    method:'POST',
                    headers: {'Content-type':'application/json'},
                    credentials:'include',
                    mode:'cors',
                    body: JSON.stringify(records[0].options.body)
                  }).then(res=>res.json()).then(res=>{
                    alert('Stocklist '+res.location+' has been saved.');
                    if (wakeLock) wakeLock.release();
                      if (res.error) {
                        navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill - Error", msf:res.error+'\nThis is an important message, please don\'t forget to screenshot or copy it and send it to Janos.\nThank you'}))});
                      }
                      else {
                       navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill",msg:'Stocklist '+res.location+' has been saved.'}))});
                      }
                    
                  }).catch((err)=>{
//                  saveAsErrored(records[0]);
                    thiz.addErrorItem(records[0].url, records[0].options, records[0].id, err);
                  });
                  setTimeout(()=>{thiz.poll()}, 10000);
                });
                return;
              }

              if (records[0].options && records[0].options.plate) {
                const formData = new FormData();
                // formDataObj.photos = [this.photos[i]];
                formData.append("plate", new Blob([records[0].options.plate], {type:"image/jpeg"}));
                delete records[0].options.plate;
                formData.append("img", new Blob([records[0].options.img], {type:"image/jpeg"}));
                delete records[0].options.img;
                formData.append("location", records[0].options.location);
                delete records[0].options.location;
                records[0].options.body = formData;
              }
              fetch(records[0].url, records[0].options).then(res=>res.json()).then(res=>{
                if (res.error) {
                  console.log(records[0].url,'application error', res);
                }
                else {
                  console.log(records[0].url, records[0].id, records[0].options,'was successfully uploaded');
                  if (records[0].url.indexOf('/saveol') != -1) {
                    const body = JSON.parse(records[0].options.body);
                    navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill", msg:'We have successfully saved offline inspection for '+body.reg }))});
                  }
                  else if (records[0].url.indexOf('/savevps') != -1) {
                    navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill", msg:'We have successfully saved an offline photoshoot.'}))});
                  }
                }
                setTimeout(()=>{thiz.poll()}, 5000);
              }).catch(err=>{
                console.log('system error',err, records[0].url, records[0].options, records[0].id);
                navigator.serviceWorker.getRegistration().then(reg=>{reg.active.postMessage(JSON.stringify({title:"24x7 Start Hill", msg:'Unable to upload job'+ records[0].id+' - '+records[0].url}))})
                thiz.addErrorItem(records[0].url, records[0].options, Date.now(), err);
                setTimeout(()=>{thiz.poll()}, 5000);
              });

              store.delete(allRecords.result[0].id);
            }
            else {
              setTimeout(()=>{thiz.poll()}, 5000);
            }
          }
        }

        request.onupgradeneeded = (event)=>{
          var db = event.target.result;
          if (!db.objectStoreNames.contains('postrequests')) {
            db.createObjectStore("postrequests", { keyPath: 'id', autoIncrement: true });
          }
          else {
            db.objectStoreNames.get('postrequests');
          }
          setTimeout(()=>{thiz.poll()}, 5000);
        };

        request.onerror = (event) => {
          console.log(event);
        };
      }
      else {
        setTimeout(()=>{thiz.poll()}, 1000);
      }
    }

    addErrorItem(url, options, id, err) {
      var r = {
        url: url,
        options:options,
        id: id || Date.now(),
        err: err
      };
      
      var request = indexedDB.open("TFSPWAPostDB");
      request.onsuccess = function (event) {
        var db = event.target.result;
        var tx = db.transaction('errorrequest', 'readwrite');
        var store = tx.objectStore('errorrequest');
        store.add(r);
      }

      request.onupgradeneeded = function (event) {
        var db = event.target.result;
        db.onerror = function (event) {
          console.log("Why didn't you allow my web app to use IndexedDB?!",event);
        };

//        var objectStore;
        if (!db.objectStoreNames.contains('errorrequest')) {
//          objectStore = 
          db.createObjectStore("errorrequest", { keyPath: 'id', autoIncrement: true });
        }
        else {
//          objectStore = 
          db.objectStoreNames.get('errorrequest');
        }
      }
    }

    addItem(url, options, id) {
      var r = {
        url: url,
        options:options,
        id: id || Date.now()
      };

      r = JSON.parse(JSON.stringify(r));
      
      var request = indexedDB.open("TFSPWAPostDB");
      request.onsuccess = function (event) {
        var db = event.target.result;
        var tx = db.transaction('postrequests', 'readwrite');
        var store = tx.objectStore('postrequests');
        store.add(r);
      }

      request.onupgradeneeded = function (event) {
        var db = event.target.result;
        db.onerror = function (event) {
          console.log("Why didn't you allow my web app to use IndexedDB?!",event);
        };

//        var objectStore;
        if (!db.objectStoreNames.contains('postrequests')) {
//          objectStore = 
          db.createObjectStore("postrequests", { keyPath: 'id', autoIncrement: true });
        }
        else {
//          objectStore = 
          db.objectStoreNames.get('postrequests');
        }
      }
    }

  }

  export default OfflineUploader
</script>

